<div class="pdf-container">
    <!-- <div class="pdf-title" *ngIf="title">
        {{title}}
        <a class="pdf-close" (click)="close()">
            <i class="far fa-times-circle"></i>
        </a>
    </div> -->
    <ngx-extended-pdf-viewer [src]="pdfURI" useBrowserLocale="true" [showSidebarButton]="true" [showFindButton]="true"
        [showPagingButtons]="true" [showZoomButtons]="true" [showPresentationModeButton]="true"
        [showOpenFileButton]="false" [showPrintButton]="true" [showDownloadButton]="true" [showBookmarkButton]="false"
        [showSecondaryToolbarButton]="false" [contextMenuAllowed]="true" showSidebarOnLoad="false">
    </ngx-extended-pdf-viewer>
</div>